import React from "react";
import uniqid from "uniqid";

export function useStableId() {
  const idRef = React.useRef<string>(uniqid());
  return idRef.current;
}
